/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Модель для подарка в корзине
   */
  app.CartGift = app.Model.extend({
    run: function () {
      this.item = new app.Item(this.get('item'));
    },
    
    getUrl: function () {
      return app.entryScriptName + '/gift/' + this.get('id') + '/';
    }
  });
})();

}.call(window));